/** @jsxImportSource @emotion/react */
import { withMyTheme } from "../../../../theme/theme"
import { css } from "@mui/material"
import { Button } from "@mui/material"
import { useTranslation } from "react-i18next"

const ButtonStyle = withMyTheme((theme) => css`
    width: 100%;
    padding: 14px 16px;
    border-radius: 12px;
    text-transform: none;
    font-size: 1rem;
    justify-content: flex-start;
    
    &:hover {
        background-color: ${theme.palette.action.hover};
    }
`)

interface QuestionSelectorButtonProps {
    onClick: () => void
    selectedQuestion?: string
}

export const QuestionSelectorButton = ({
    onClick,
    selectedQuestion
}: QuestionSelectorButtonProps) => {
    const { t } = useTranslation()

    return (
        <Button
            variant="outlined"
            onClick={onClick}
            css={ButtonStyle}
        >
            {selectedQuestion || t('questionnaire.guestsFAQ.questionSelector')}
        </Button>
    )
}
